











 









const node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OrgAuthenticationSSOFrame_saml",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "domains",
      "storageKey": null
    }
  ],
  "type": "SAML",
  "abstractKey": null
};

(node ).hash = "1863e2ea6f32d3fd396a203951825b49";

export default node;
